import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { BaseComponent } from "./base/base.component";

const routes: Routes = [
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./../../views/pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "users",
        loadChildren: () =>
          import("./../../views/pages/master/user/user.module").then(
            (m) => m.UserModule
          ),
      },
      {
        path: "profile/:id/:actionInfo",
        loadChildren: () =>
          import("./../../views/pages/profile/profile/profile.module").then(
            (m) => m.ProfileModule
          ),
      },
      {
        path: "monthlyreport",
        loadChildren: () =>
          import(
            "./../../views/pages/reports/monthlyreport/monthlyreport.module"
          ).then((m) => m.MonthlyReportModule),
      },
      {
        path: "genderwisechildcount",
        loadChildren: () =>
          import(
            "./../../views/pages/reports/genderwisechildcountreport/genderwisechildcountreport.module"
          ).then((m) => m.GenderWiseChildcountReportModule),
      },
      {
        path: "district",
        loadChildren: () =>
          import("./../../views/pages/master/district/district.module").then(
            (m) => m.DistrictModule
          ),
      },
      {
        path: "block",
        loadChildren: () =>
          import("./../../views/pages/master/block/block.module").then(
            (m) => m.BlockModule
          ),
      },
      {
        path: "sector",
        loadChildren: () =>
          import("./../../views/pages/master/sector/sector.module").then(
            (m) => m.SectorModule
          ),
      },
      {
        path: "awc",
        loadChildren: () =>
          import("./../../views/pages/master/awc/awc.module").then(
            (m) => m.AwcModule
          ),
      },
      {
        path: "grid",
        loadChildren: () =>
          import("./../../views/pages/grid/grid.module").then(
            (m) => m.gridModule
          ),
      },
      {
        path: "villagewisereport",
        loadChildren: () =>
          import(
            "./../../views/pages/reports/district-wise-report/district-report.module"
          ).then((m) => m.DistrictReportModule),
      },
      {
        path: "schoolwisereport",
        loadChildren: () =>
          import(
            "./../../views/pages/reports/schoolwisereport/schoolwisereport.module"
          ).then((m) => m.SchoolReportModule),
      },
      {
        path: 'addlibrary/:id/:actionInfo',
        loadChildren: () => import('./../../views/pages/master/addlibrary/addlibrary.module').then(m => m.AddlibraryModule)
      },
      {
        path: 'adduser/:id/:actionInfo',
        loadChildren: () => import('./../../views/pages/master/adduser/adduser.module').then(m => m.AdduserModule)
      },
      {

        path: 'library',
        loadChildren: () => import('./../../views/pages/master/library/library.module').then(m => m.LibraryModule)
      },
      {

        path: 'employee',
        loadChildren: () => import('./../../views/pages/master/userpage/userpage.module').then(m => m.UserpageModule)
      },
      {

        path: 'reports',
        loadChildren: () => import('./../../views/pages/master/report/report.module').then(m => m.ReportModule)
      },
      {

        path: 'member/:id/:actionInfo',
        loadChildren: () => import('./../../views/pages/master/members/members.module').then(m => m.MembersModule)
      },
      {
        path: 'reportpopup',
        loadChildren: () => import('./../../views/pages/master/reportpopup/reportpopup.module').then(m => m.ReportpopupModule)
      },
      {
        path: 'members',
        loadChildren: () => import('./../../views/pages/master/memberspage/memberspage.module').then(m => m.MemberspageModule)
      },
      {
        path: 'memberreport',
        loadChildren: () => import('./../../views/pages/master/memberreport/memberreport.module').then(m => m.MemberreportModule)
      },
      {
        path: 'reportlibrary',
        loadChildren: () => import('./../../views/pages/master/libraryreport/libraryreport.module').then(m => m.LibraryreportModule)
      },
      {
        path: 'attendancereport',
        loadChildren: () => import('./../../views/pages/master/attendancereport/attendancereport.module').then(m => m.AttendancereportModule)
      },
      {
        path: 'infrastructure',
        loadChildren: () => import('./../../views/pages/master/ownership/ownership.module').then(m => m.OwnershipModule )
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule { }
